import { classNames } from "../utils/styles";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import React from "react";

const KnowledgeSourceRow = ({
  source,
  handleCheckboxChange,
  checkBoxes,
  renderIcon,
  renderTitle,
  index,
  disableSource,
  enableSource,
  removeSource,
}) => {
  return (
    <tr className="even:bg-gray-50 border-t hover:bg-gray-50 text-sm">
      <td className="flex items-center relative py-4 pl-4 pr-3 text-sm sm:pl-6">
        <input
          type="checkbox"
          checked={checkBoxes[source.id]}
          onChange={() => handleCheckboxChange(source.id)}
          className="hidden pt-2 mr-3 appearance-none h-5 w-5 border border-gray-300 rounded-md checked:bg-gray-300 checked:border-transparent focus:outline-none transition duration-200"
        />
        {renderIcon(source.data_source_name)}
        <div className="ml-1">
          <div className="font-medium">
            {renderTitle(source.data_source_name)}
          </div>
          <span className="text-gray-500 text-sm">{source.source_name}</span>
        </div>
      </td>

      <td
        className={classNames(
          index === 0 ? "" : "border-t border-gray-200",
          "hidden px-3 py-3.5 text-sm text-gray-500 sm:table-cell"
        )}
      >
        <span className="inline-flex items-center px-2 py-1 rounded-md text-sm font-medium border shadow">
          <span
            className={`mr-1 w-2 h-2 rounded-full ${source.is_live ? "bg-green-500" : "bg-gray-500"}`}
          ></span>
          {source.is_live ? "Active" : "Inactive"}
        </span>
      </td>

      <td
        className={classNames(
          index === 0 ? "" : "border-t border-gray-200",
          "hidden px-3 py-3.5 text-sm text-gray-500 sm:table-cell"
        )}
      >
        <p className="font-medium text-gray-900">
          {new Intl.NumberFormat("en-us").format(source.chars_count)}
        </p>
      </td>

      <td className="py-4 px-6 text-right w-0">
        <Menu as="div" className="relative inline-block text-left">
          <MenuButton className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
            <span className="sr-only">Open options</span>
            <EllipsisVerticalIcon aria-hidden="true" className="h-5 w-5" />
          </MenuButton>
          <MenuItems
            transition
            className="absolute right-0 z-10 mt-2 w-20 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
          >
            <MenuItem>
              <button
                type="button"
                className="cursor-pointer block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
                onClick={() =>
                  source.is_live
                    ? disableSource(source.id)
                    : enableSource(source.id)
                }
              >
                {source.is_live ? "Disable" : "Enable"}
              </button>
            </MenuItem>
            <MenuItem>
              <button
                type="button"
                className="cursor-pointer block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
                onClick={() => removeSource(source.id)}
              >
                Remove
              </button>
            </MenuItem>
          </MenuItems>
        </Menu>
      </td>
    </tr>
  );
};

export default KnowledgeSourceRow;
